import { NumericFormat } from 'react-number-format'

export function CustomPriceInput(props) {
  return (
    <NumericFormat
      allowLeadingZeros={false}
      allowNegative={false}
      prefix="R$ "
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      fixedDecimalScale={true}
      {...props}
      className="form-control"
    />
  )
}
